import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';
import { MonthlyFinancial } from '../../types/dashboard';

interface RevenueChartProps {
  data: MonthlyFinancial[] | undefined;
  loading?: boolean;
  formatCurrency: (amount: number) => string;
}

const RevenueChart: React.FC<RevenueChartProps> = ({ data, loading, formatCurrency }) => {
  if (loading) {
    return (
      <div className="card border-0 shadow-sm h-100">
        <div className="card-body">
          <h6 className="card-title text-muted mb-3">Revenue (12 months)</h6>
          <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 260 }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (!data || data.length === 0) {
    return (
      <div className="card border-0 shadow-sm h-100">
        <div className="card-body">
          <h6 className="card-title text-muted mb-3">Revenue (12 months)</h6>
          <div className="d-flex align-items-center justify-content-center text-muted" style={{ minHeight: 260 }}>
            No data
          </div>
        </div>
      </div>
    );
  }
  const chartData = data.map((d) => ({
    ...d,
    shortMonth: d.month.slice(0, 7)
  }));
  return (
    <div className="card border-0 shadow-sm h-100">
      <div className="card-body">
        <h6 className="card-title text-muted mb-3">Revenue (12 months)</h6>
        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={chartData} margin={{ top: 5, right: 5, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
            <XAxis dataKey="shortMonth" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} tickFormatter={(v) => (v >= 1000 ? `${v / 1000}k` : String(v))} />
            <Tooltip
              labelFormatter={(_, payload) => payload?.[0]?.payload?.month}
              formatter={(value) => [formatCurrency(Number(value ?? 0)), 'Revenue']}
            />
            <Bar dataKey="revenue" name="Revenue" fill="#006175" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RevenueChart;
